const SubAbasGlossario = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/home/glossario/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasGlossario;
